import style from "../../assets/scss/common/header.module.scss";
import closeBtn from "../../assets/images/drawer_menu/top_menu_drawer_close_btn.svg";
import rightArrow from "../../assets/images/drawer_menu/right_arrow.svg";
import rightArrowMobile from "../../assets/images/drawer_menu/right_arrow_mobile.svg";
import logoutIcon from "../../assets/images/drawer_menu/logout_icon.svg";
import downloadIcon from "../../assets/images/drawer_menu/drawer_download_icon.svg";
import downloadIconBold from "../../assets/images/drawer_menu/drawer_download_icon_bold.svg";
import voucherIcon from "../../assets/images/drawer_menu/drawer_voucher_icon.svg";
import voucherIconBold from "../../assets/images/drawer_menu/drawer_voucher_icon_bold.svg";
import partnershipIcon from "../../assets/images/drawer_menu/partnership_icon.svg";
import partnershipIconBold from "../../assets/images/drawer_menu/partnership_icon_bold.svg";
import partnerIcon from "../../assets/images/drawer_menu/partner_icon.svg";
import partnerIconBold from "../../assets/images/drawer_menu/partner_icon_bold.svg";
import searchIcon from "../../assets/images/drawer_menu/search-icon.svg";
import {Link, useLocation} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {useAppSelector, useAuth, useLanguage, useModal, useUserAgent} from "../../hooks/hooks";
import {ModalType} from "../../types/common";
import {userDetail} from "../../store/user/userSlice";
import {Trans, useTranslation} from "react-i18next";
import {useClickEvent} from "../../hooks/useClickEvent";
import {CLICK_TARGET_NAME} from "../../util/events";
import {useCookie} from "../../hooks/auth/useCookie";
import {CookieKeys} from "../../hooks/auth/AuthProvider";

interface Props {
  showDrawer: boolean;
  closeDrawer: VoidFunction;
  signOut: VoidFunction;
}

export function DrawerMenu({ showDrawer, closeDrawer, signOut }: Props) {
  const { t } = useTranslation(["drawerMenu"]);
  const { openModal, openConfirmModal, openAlertModal } = useModal();
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  const [activePath, setActivePath] = useState("home");
  const userInfo = useAppSelector(userDetail);
  const { isNotKorean, isKorean } = useLanguage();
  const drawerRef = useRef<HTMLDivElement>(null);
  const { isTablet, isMobile } = useUserAgent();
  const {getValueFromCookie} = useCookie();
  const [isIntroductionSelected, setIsIntroductionSelected] = useState(false)
  useClickEvent({ elementRefs: [drawerRef], doOnClickBg: closeDrawer });

  useEffect(() => {
    const pathArr = location.pathname.split("/");
    setActivePath(pathArr[1]);
  }, [location]);

  const onClickLink = () => {
    window.scrollTo(0, 0);
    setIsIntroductionSelected(false);
    closeDrawer();
  };

  const onClickToggleLink = () => {
    window.scrollTo(0, 0);
    closeDrawer();
  }

  const onClickLoginBtn = (e: React.MouseEvent) => {
    openModal(ModalType.LOGIN);
    e.stopPropagation();
  };

  const onClickIntroduction = () => {
    setIsIntroductionSelected(() => !isIntroductionSelected)
  }

  const handleSimpleTestClick = (e: React.MouseEvent) => {
    console.log(isLoggedIn)
    e.preventDefault();

    if (!isLoggedIn) {
      openAlertModal({
        title: "두뇌유형검사 안내",
        desc: "두뇌유형검사는\n로그인 후 이용 가능합니다.",
        callback: () => {
          closeDrawer();
          openModal(ModalType.LOGIN)
        },
      });

      return;
    }

    const accessToken = getValueFromCookie(CookieKeys.ACCESS_TOKEN);
    const refreshToken = getValueFromCookie(CookieKeys.REFRESH_TOKEN);
    const url = `https://brain.feel-good.io?accessToken=${accessToken}&refreshToken=${refreshToken}`
    if (isTablet) {
      openConfirmModal(
        {
          title: "두뇌유형검사 안내",
          desc: "두뇌유형검사는 태블릿에서 \n가로모드로 지원 합니다. \n가로모드 전환 후 확인을 눌러주세요.",
        },
        () => {
          window.open(url, "_blank", "noopener,noreferrer");
        }
      );
    } else if (isMobile) {
      openConfirmModal(
        {
          title: "두뇌유형검사 안내",
          desc: "두뇌유형검사는 태블릿에서 \n가로모드로 지원 합니다. \n모바일은 진행이 어려울 수 있습니다. \n가로모드 전환 후 확인을 눌러주세요.",
        },
        () => {
          window.open(url, "_blank", "noopener,noreferrer");
        }
      );
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const onClickLogoutBtn = () => signOut();
  const groupMemberUrl = process.env.REACT_APP_MODE === "운영"
      ? "https://group-member.feel-good.io/"
      :"https://group-member-dev.feel-good.io/"
  const onClickGroupMemberPage = () => window.open(groupMemberUrl)
  const { isDesktop } = useUserAgent();

  const BeforeLoginNode = () => (
    <>
        <div className={style.beforeLogin}>
          <button className={style.loginBtn} onClick={onClickLoginBtn}>
            <span className={style.btnText}>{t("kpassLogin")}</span>
            <img src={isDesktop ? rightArrow : rightArrowMobile} alt={"right arrow"} />
          </button>
        </div>
    </>
  );

  const AfterLoginNode = () => (
    <div className={style.afterLogin}>
      <div className={style.welcome}>
        <div className={style.text}>
          <Trans t={t} i18nKey={"greeting"}
                 components={{bold: <span className={style.accent}/>}}
                 values={{name : userInfo?.name, blank: '\u00A0'}}
          />
        </div>
      </div>
      <p className={style.desc}>
        <Link
          onClick={onClickLink}
          className={`${style.mypageMenu} ${activePath === "mypage" ? style.active : ""}`}
          to="/mypage"
        >
          <span className={style.menuName} style={{ color: "#583BE2" }}>
            {t("myPage")}
          </span>
        </Link>
      </p>
    </div>
  );

  useEffect(() => {
    if (showDrawer) {
      document.querySelector("html")!.style.overflowY = "hidden";
    } else {
      document.querySelector("html")!.style.overflowY = "auto";
    }
  }, [showDrawer]);

  return (
    <div className={style.drawerArea}>
      <div className={`${style.drawerBg} ${showDrawer ? style.show : ""}`}></div>
      <div
        className={`${style.drawer} ${isNotKorean ? style.ru : ""} ${showDrawer ? style.show : ""}`}
        ref={drawerRef}
        data-name={CLICK_TARGET_NAME}
      >
        <button className={style.closeBtn} onClick={closeDrawer}>
          <img src={closeBtn} alt={t("closeButton")} />
        </button>

        {isLoggedIn ? <AfterLoginNode /> : <BeforeLoginNode />}

        <div className={style.navWrapper}>
          <nav className={style.nav}>
            <ul className={`${style.navList} ${isNotKorean ? style.ru : ""}`}>
              {isKorean && (
                <li className={`${style.menu}`}>
                  <Link
                    onClick={handleSimpleTestClick}
                    className={`${activePath === "" ? style.active : ""} ${style.noGap}`}
                    to="#"
                  >
                    <img src={searchIcon} className={style.searchIcon} alt={'searchIcon'}/>
                    <span className={style.simpleTestMenu}>{t("simpleTest")}</span>
                    <span className={style.freeProviding}>무료 체험!</span>
                  </Link>
                </li>
              )}

              <li className={style.menu}>
                <Link onClick={onClickLink} className={activePath === "" ? style.active : ""} to="/">
                  <span className={style.menuName}>{t("menuHome")}</span>
                  <span className={`${style.activeMenuName} ${isNotKorean ? style.notKO : ""}`}>{t("menuHome")}</span>
                </Link>
              </li>
              <li className={style.menu}>
                <Link
                  onClick={onClickLink}
                  className={activePath === "startguide" ? style.active : ""}
                  to="/startguide"
                >
                  <span className={style.menuName} style={{ color: "#583BE2" }}>
                    {t("startGuide")}
                  </span>
                  <span
                    className={`${style.activeMenuName} ${isNotKorean ? style.notKO : ""}`}
                    style={{ color: "#583BE2" }}
                  >
                    {t("startGuide")}
                  </span>
                </Link>
              </li>
              <li className={style.menu}>
                <div
                    style={{cursor:"pointer", gap:"10px"}}
                    onClick={onClickIntroduction}
                    className={activePath === "introduction" ? style.active : ""}
                >
                  <span className={`${style.menuName} ${isIntroductionSelected ? style.bold : ""}`}>{t("introduction")}</span>
                  <span className={`${style.activeMenuName} ${isNotKorean ? style.notKO : ""}`}>
                    {t("introduction")}
                  </span>
                  <div className={`${style.arrow} ${isIntroductionSelected ? style.upper : style.lower}`} />
                </div>
              </li>
              {isIntroductionSelected && (
                  <>
                    <li className={`${style.menu} ${style.toggle}`}>
                      <Link
                          onClick={onClickToggleLink}
                          className={activePath === "understanding" ? style.active : ""}
                          to="/understanding/kpass"
                      >
                        <span className={style.menuName}>{t("understandingKpass")}</span>
                        <span className={`${style.activeMenuName} ${isNotKorean ? style.notKO : ""}`}>
                          {t("understandingKpass")}
                        </span>
                      </Link>
                    </li>
                    <li className={`${style.menu} ${style.toggle}`}>
                      <Link
                          onClick={onClickToggleLink}
                          className={activePath === "purpose-and-characteristics" ? style.active : ""}
                          to="/purpose-and-characteristics"
                      >
                        <span className={style.menuName}>{t("purposeAndCharacteristics")}</span>
                        <span className={`${style.activeMenuName} ${isNotKorean ? style.notKO : ""}`}>
                          {t("purposeAndCharacteristics")}
                        </span>
                      </Link>
                    </li>
                    <li className={`${style.menu} ${style.toggle}`}>
                      <Link
                          onClick={onClickToggleLink}
                          className={activePath === "researcher" ? style.active : ""}
                          to="/researcher"
                      >
                        <span className={style.menuName}>{t("researcher")}</span>
                        <span className={`${style.activeMenuName} ${isNotKorean ? style.notKO : ""}`}>{t("researcher")}</span>
                      </Link>
                    </li>
                  </>
              )}
              <li className={style.menu}>
                <Link onClick={onClickLink} className={activePath === "review" ? style.active : ""} to="/review?page=0">
                  <span className={style.menuName}>{t("realReview")}</span>
                  <span className={`${style.activeMenuName} ${isNotKorean ? style.notKO : ""}`}>{t("realReview")}</span>
                </Link>
              </li>
              <>
                <li className={style.menu}>
                  <Link
                    onClick={onClickLink}
                    className={`${style.purchasePage} ${style.withIcon} ${
                      activePath === "purchase-voucher" ? style.active : ""
                    }`}
                    to="/purchase-voucher"
                  >
                    <img className={style.normalIcon} src={voucherIcon} alt={"이용권"} />
                    <img className={style.activeIcon} src={voucherIconBold} alt={"이용권"} />
                    <span className={style.menuName}>{t("purchaseVoucher")}</span>
                    <span className={style.activeMenuName}>{t("purchaseVoucher")}</span>
                    <span className={style.discountBadge}>
                      {/* 여름 기한 한정 문구 변경임 */}
                      {/*추가혜택 제공!*/}
                      {/*여름방학 특가!*/}
                      {/*신학기 할인!*/}
                      {/*봄맞이 할인!*/}
                      {/*{isKorean ? `특별할인 혜택!` : ""}*/}
                    </span>
                  </Link>
                </li>
                <li className={style.menu}>
                  <Link
                    onClick={onClickLink}
                    className={`${style.downloadPage} ${style.withIcon} ${
                      activePath === "download-test" ? style.active : ""
                    }`}
                    to="/download-test"
                  >
                    <img className={style.normalIcon} src={downloadIcon} alt={"검사 다운로드"} />
                    <img className={style.activeIcon} src={downloadIconBold} alt={"검사 다운로드"} />
                    <span className={style.menuName}>{t("downloadTest")}</span>
                    <span className={style.activeMenuName}>{t("downloadTest")}</span>
                  </Link>
                </li>
                <li className={style.menu}>
                  <Link
                    onClick={onClickLink}
                    className={`${style.partnership} ${style.withIcon} ${
                      activePath === "partnership" ? style.active : ""
                    }`}
                    to="/partnership"
                  >
                    <img className={style.normalIcon} src={partnershipIcon} alt={"제휴 문의"} />
                    <img className={style.activeIcon} src={partnershipIconBold} alt={"제휴 문의"} />
                    <span className={style.menuName}>{t("partnership")}</span>
                    <span className={style.activeMenuName}>{t("partnership")}</span>
                  </Link>
                </li>
                {isKorean && (
                  <li className={style.menu}>
                    <Link
                      onClick={onClickLink}
                      className={`${style.partnerlist} ${style.withIcon} ${
                        activePath === "partnerlist" ? style.active : ""
                      }`}
                      to="/partnerlist"
                    >
                      <img className={style.normalIcon} src={partnerIcon} alt={"협력사"} />
                      <img className={style.activeIcon} src={partnerIconBold} alt={"협력사"} />
                      <span className={style.menuName}>협력사</span>
                      <span className={style.activeMenuName}>협력사</span>
                    </Link>
                  </li>
                )}
              </>
            </ul>
          </nav>
        </div>
        {!isLoggedIn && (
          <div className={style.organMemberWrapper} onClick={onClickGroupMemberPage}>
            <span className={style.desc}>
              {t('groupMember')}
            </span>
            <div className={style.organArrow}/>
          </div>
        )}

        {isLoggedIn && (
          <button className={style.logoutBtn} onClick={onClickLogoutBtn}>
            <span className={style.text}>{t("logout")}</span>
            <img src={logoutIcon} alt={"로그아웃 아이콘"} />
          </button>
        )}
      </div>
    </div>
  );
}
